export default __webpack_public_path__ + "static/media/asters_placeholder.42961f11.png";